module.exports = __webpack_public_path__ + "assets/img/index_banner.1444ff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_banner.png
// module id = /AvU
// module chunks = 1